import React, { useState } from "react";
import {
  Upload,
  Button,
  message,
  notification,
  Modal,
  Form,
  Row,
  Col,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
 import ImgCrop from "antd-img-crop";
import Idame from "../ReportFormGenerator/Idame/Idame";
import CropDown from "../ReportFormGenerator/CropDown/CropDown";
import But from "../ReportFormGenerator/Button/Button";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import { ExclamationCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { isHidden } from "@amcharts/amcharts4/.internal/core/utils/DOM";
import { useSelector } from "react-redux";

const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message: message,
  });
};

const { confirm } = Modal;

const Uploader = () => {
  const urlCode = useSelector(state => state.urlCode);
  const [fileList, updateFileList] = useState([]);
  const [form] = Form.useForm();
  const [headerData, setHeaderData] = useState(null);
  const [mdictType, setMdictType] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [loginError, setLoginError] = useState(false);
  const [reqMethod, setReqMethod] = useState("POST");

  const [loading, setLoading] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(null);
  const [modalLoading, setModalLoading] = useState(true);
  const [IMG, setIMG] = useState(null);
  const [noImg, setNoImg] = useState(false);

  const uplBtnRef = React.useRef();

  const props = {
    name: "file",
    method: "POST",
    action: `${
      process.env.REACT_APP_API_ENDPOINT
    }/file?token=${localStorage.getItem("token")}&urlCode=${urlCode}`,
    headers: {
      authorization: "authorization-text",
    },
    beforeUpload: (file, fileList) => {
      
    },
    onChange: (info) => {
      
      if (info.file.status == "done") {
        openNotificationWithIcon(
          "success",
          `Uploaded ${info.file.name} Successfully`
        );
      }
      if (info.file.status == "error") {
        openNotificationWithIcon(
          "error",
          `Uploaded ${info.file.name} Failed !`
        );
      }
      // updateFileList(info.fileList.filter((file) => !!file.status));
    },
  };

  //   const props = {
  //     fileList,
  //     method: reqMethod,
  //     action: `${
  //       process.env.REACT_APP_API_ENDPOINT
  //     }/img?token=${localStorage.getItem("token")}`,
  //     beforeUpload: (file) => {
  //       console.log(file);
  //       if (
  //         file.type == "image/png" ||
  //         file.type == "image/jpeg" ||
  //         file.type == "image/jpg"
  //       ) {
  //         return file.type === "image/png" || file.type === "image/jpeg";
  //       } else {
  //         message.error(`${file.name} is not a png/jpg file`);
  //       }
  //     },
  //     onChange: (info) => {
  //       console.log(info);
  //       if (info.file.status == "done") {
  //         openNotificationWithIcon(
  //           "success",
  //           `Uploaded ${info.file.name} Successfully`
  //         );
  //       }
  //       if (info.file.status == "error") {
  //         openNotificationWithIcon(
  //           "error",
  //           `Uploaded ${info.file.name} Failed !`
  //         );
  //       }
  //       // updateFileList(info.fileList.filter((file) => !!file.status));
  //     },
  //   };

  const onFinish = (values) => {
    setLoading(true);
    setHeaderData(values);

    // values["_id"] = values["subTyp"];
    const fileId = values["typ"] + "_" + values["subTyp"];

    values["_id"] = fileId;

    

    // showConfirm();
    liracrypt
      .get("/misc/image/single", values)
      .then((res, req) => {
        if (res.status === 204) {
          setReqMethod("POST");
          uplBtnRef.current.click();
        } else if (res.status === 200) {
          showConfirm(values);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });

    // uplBtnRef.current.click();
  };

  const onChange = (value) => {
    setMdictType(value);
  };

  function showConfirm(values) {
    confirm({
      title: "File Already Exist !",
      icon: <ExclamationCircleOutlined />,
      okText: <span style={{ fontWeight: 600 }}>Replace</span>,
      cancelText: <span style={{ fontWeight: 600 }}>Cancel</span>,
      cancelButtonProps: { ghost: true, danger: true },
      okButtonProps: { ghost: true },
      onOk() {
        
        setReqMethod("PUT");
        setHeaderData({ _id: values["subTyp"] });
        uplBtnRef.current.click();
      },
      onCancel() {
        
      },
    });
  }

  const IdameRef = () => {
    return (
      <>
        {mdictType ? (
          <Idame
            // width = {100}
            form={form}
            type="name"
            url="/mdict"
            urlData={{
              typ: mdictType,
              subTyp: "ijoint",
              includeAll: false,
            }}
            idName="subTyp"
            idLabel="SubType"
            idErrorMessage={`Please Select ${mdictType}`}
            idRequired={true}
            idPlaceholder={`Select ${mdictType}`}
            nameName="subTypName"
            nameLabel="SubType"
            nameErrorMessage={`Please Select ${mdictType}`}
            nameRequired={true}
            namePlaceholder={`Select ${mdictType}`}
          />
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <>
      <SessionError visible={loginError} />

      {/* <StablePrime url="/misc/image/multi" data={{}} identity="Images" /> */}
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            name="ReportForm"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row justify="center">
              <Col span={12}>
                <CropDown
                  form={form}
                  name="typ"
                  // defaultValue={{ label: "Line", value: "Line" }}
                  label="Type"
                  placeholder="Select Type"
                  url="/cropdown"
                  urlData={{ name: "ImageUpload" }}
                  required={true}
                  errorMessage="Please Select Type"
                  onChange={onChange}
                />
              </Col>
            </Row>
            <Row justify="center">
              <Col span={12}>
                <IdameRef />
              </Col>
            </Row>
            <Row gutter={24} justify="center">
              <Col span={24}>
                <But
                  form={form}
                  submitButtonText={"Upload File"}
                  loading={loading}
                  resetButton={true}
                ></But>

                <Upload {...props} headers={headerData}>
                  <Button
                    // type="primary"
                    // htmlType="submit"
                    ref={uplBtnRef}
                    style={{ fontWeight: 600, visibility: "hidden" }}
                    type="danger"
                    icon={<UploadOutlined />}
                  >
                    Upload File
                  </Button>
                </Upload>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Uploader;
